// test925
(925 && 0);
